import { hasClass, removeClass, addClass } from '../tools/helpers';

function reOffset(param) {
  const card = param;
  const headline = card.getElementsByClassName('symbol-card__headline')[0];

  const inner = card.getElementsByClassName('symbol-card__inner')[0];
  const computedStyle = getComputedStyle(inner);

  // eslint-disable-next-line max-len
  const elementHeight = inner.clientHeight - (parseFloat(computedStyle.paddingTop) + parseFloat(computedStyle.paddingBottom));

  const headlineHeight = headline.offsetHeight;
  headline.style.transform = `translate3d(0, ${elementHeight - headlineHeight}px, 0)`;
}

const symbolCards = document.getElementsByClassName('symbol-card');

symbolCards.forEach((param) => {
  const card = param;
  setTimeout(() => {
    reOffset(card);
  }, 500);

  card.addEventListener('click', (evt) => {
    if (!hasClass(evt.currentTarget, 'symbol-card--active')) {
      addClass(evt.currentTarget, 'symbol-card--active');
      const headline = evt.currentTarget.getElementsByClassName('symbol-card__headline')[0];
      headline.style.transform = 'translate3d(0, 0, 0)';
    } else {
      removeClass(evt.currentTarget, 'symbol-card--active');
      reOffset(evt.currentTarget);
    }
  });
});

window.addEventListener('resize', () => {
  symbolCards.forEach((card) => {

    if (!hasClass(card, 'symbol-card--active')) {
      reOffset(card);
    }
  });
});





// WEBPACK FOOTER //
// ./src/javascript/main/symbolCards.js